import React from 'react';

const BrandIcon: React.FC = () => {
  return <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.978 3.015V12.5l-2.163-1.235A12.414 12.414 0 0 1 3.589.5H2v10.853c0 3.53 2.03 6.794 5.254 8.338l4.768 2.294V12.5l2.163 1.235A12.414 12.414 0 0 1 20.411 24.5H22V13.647c0-3.53-2.03-6.794-5.254-8.338l-4.768-2.294Z" fill="#fff"/></svg>;
};
export default BrandIcon;
